<template>
  <b-modal id="edit-ticket-details-modal" title="Edit Ticket" size="lg" hide-footer>
    <loading-screen :is-loading="isSaving"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <div class="form-group mb-4">
      <label for="subject">Subject</label>
      <input
          id="subject"
          name="subject"
          type="text"
          class="form-control"
          v-model="subject"
      />
    </div>

    <div class="form-group mb-4">
      <label for="axum_booking_id">AXUM Booking ID</label>
      <input
          id="axum_booking_id"
          name="axum_booking_id"
          type="text"
          class="form-control"
          v-model="axum_booking_id"
      />
    </div>

    <div class="form-group mb-2">
      <label for="description" class="">Description</label>
      <div class="card shadow-none card-action">
        <div class="card-body pb-0">
          <editor-content :editor="editor"/>
        </div>
        <div class="card-menubar">
          <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="menubar">

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 :class="{ 'is-active': isActive.bold() }"
                 @click="commands.bold"
              >
                <i class="fas fa-bold"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 :class="{ 'is-active': isActive.italic() }"
                 @click="commands.italic"
              >
                <i class="fas fa-italic"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 :class="{ 'is-active': isActive.strike() }"
                 @click="commands.strike"
              >
                <i class="fas fa-strikethrough"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 :class="{ 'is-active': isActive.underline() }"
                 @click="commands.underline"
              >
                <i class="fas fa-underline"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 :class="{ 'is-active': isActive.bullet_list() }"
                 @click="commands.bullet_list"
              >
                <i class="fas fa-list-ul"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 :class="{ 'is-active': isActive.ordered_list() }"
                 @click="commands.ordered_list"
              >
                <i class="fas fa-list-ol"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 @click="commands.undo"
              >
                <i class="fas fa-undo"></i>
              </a>

              <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                 @click="commands.redo"
              >
                <i class="fas fa-redo"></i>
              </a>
            </div>
          </editor-menu-bar>
        </div>
      </div>
    </div>

    <button type="submit" class="btn btn-itg-dark" :disabled="isSaving"
            @click.prevent="save">
      Save
    </button>
  </b-modal>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Forms from "../../../../../mixins/Forms";
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import {
  Blockquote, Bold,
  BulletList, Code,
  CodeBlock,
  HardBreak,
  Heading, History, Italic, Link,
  ListItem,
  OrderedList, Strike,
  TodoItem, TodoList, Underline
} from "tiptap-extensions";
import axios from 'axios';

export default {
  name: "EditTicketDetailsModal",
  components: {Editor, EditorContent, EditorMenuBar},
  mixins: [Forms],
  data() {
    return {
      isSaving: false,
      serverErrors: [],

      subject: null,
      previous_axum_booking_id: null,
      axum_booking_id: null,
      editor: null
    }
  },
  mounted() {
    this.setupEditor();
  },
  created() {
    this.subject = this.ticket.subject;
    this.previous_axum_booking_id = this.ticket.axum_booking_id;
    this.axum_booking_id = this.ticket.axum_booking_id;
  },
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    })
  },
  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    setupEditor() {
      let vm = this;
      this.editor = new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({levels: [1, 2, 3]}),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: this.ticket.description
      })
    },

    save() {
      if (this.isSaving) {
        return false;
      }

      let vm = this;
      vm.isSaving = true;

      axios.put(API_BASE + '/tickets/' + this.ticket.id, {
        subject: vm.subject,
        axum_booking_id: vm.axum_booking_id,
        description: vm.editor.getHTML()
      }).then(r => {
        vm.isSaving = false;
        vm.reloadTicket();
        vm.$bvModal.hide('edit-ticket-details-modal');
      }).catch(e => {
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  }
}
</script>

<style scoped>

</style>
